$(document).ready(function () {

    $('.js-mailchimp-submit').on('click', function (e) {

        e.preventDefault();

        var form = $(this).closest('.js-mailchimp-form');
        var email = form.find('.js-mailchimp-email').val();

        //Validation
        var errors = [];
        var valid = true;
        var message = '';

        //Check required fields
        var response = form.checkRequiredFields();

        if (!response.valid) {
            valid = false;
            message = "<p>Please complete these required fields to continue...</p> <ul><li>" + response.empty_fields.join('</li><li>') + "</li></ul>";
            errors.push(message);
        }

        if (valid) {

            var url = "../php/ajax/mailchimp.php?action=join";

            var post_data = {
                email: email
            };

            $.post(url, post_data, function (data) {

                try {
                    response = JSON.parse(data);

                    console.log('response', response);

                    if (response.valid) {
                        dialogify('<h2>Signed up</h2><p>Thank you, you have successfully joined our mailing list.</p>');
                        $('.js-mailchimp-email').val('');
                    } else {
                        dialogify(response.error_message);
                    }

                } catch (e) {
                    dialogify(e + '<hr />' + data);
                }

            });

        } else {
            //If errors happened tell the user
            if (!valid) {
                message = errors.join('<br />');
                dialogify(message);
            }
        }

    });

});